export class GetNotificationsModel {
  constructor(public Skip: number = 0, public PageSize: number = 5) {}
}
